export default function WhatIs() {
  return (
    <section id="what-is" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            What Is Vigorbuy Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Vigorbuy Spreadsheet is a curated product discovery system that helps shoppers organize product links, compare options, review QC photos, and discover trending items. Instead of manually searching thousands of products, users can explore organized spreadsheets that save time and improve purchasing decisions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-background-100 rounded-lg p-6 md:p-8">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
              <i className="ri-search-line text-lg"></i>
            </div>
            <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">Curated Product Discovery</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              The Vigorbuy Spreadsheet brings together hand-picked products across multiple categories, saving you from scrolling through endless listings. Each product is carefully selected and verified for quality, making your shopping experience faster and more enjoyable.
            </p>
          </div>

          <div className="bg-background-100 rounded-lg p-6 md:p-8">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
              <i className="ri-file-list-3-line text-lg"></i>
            </div>
            <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">Organized Information</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Unlike traditional search results that scatter product information across multiple pages, the Vigorbuy Spreadsheet organizes everything in a structured format. Compare prices, sizes, QC photos, and seller ratings all in one convenient location.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}